import LabelledSwitch from '../LabelledSwitch';
import TitledPanel from '../TitledPanel';
import MenuSelector from '../MenuSelector';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import CreateButton from '../CreateButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { MAX_INTEGRATIONNAME_LENGTH, MAX_LONGIRI_LENGTH } from '../utils/constants';
import { fullySanitiseText, checkIRI, sanitiseText } from '../utils/utils';

const menuOptions = [
    {
        "value": "application/ld+json",
        "label": "JSON-LD"
    }, {
        "value": "text/turtle",
        "label": "Turtle"
    }
];

class CreateIntegrationDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isValidIRI: true,
            open: false,
            name: "",
            endpoint: "",
            changesOnly: false,
            format: "application/ld+json"
        };
        this.cancellable = null;
    }

    handleNameChange = (event) => {
        const t = event.target;
        const cleanText = fullySanitiseText(t.value);
        this.setState({ [t.name]: cleanText });
    };

    handleIRIChange = event => {
        const t = event.target;
        const cleanText = sanitiseText(t.value);
        const isValidIRI = t.value === "" || checkIRI(cleanText, true);
        this.setState({ endpoint: cleanText, isValidIRI });
    };

    handleFormatChange = (format) => this.setState({ format });

    handleClickOpen = () => { this.setState({ open: true }); };

    createIntegration = () => {
        const { name, endpoint, format, changesOnly } = this.state;
        this.props.onCreateIntegration({
            name,
            endpoint,
            format,
            changesOnly
        });
        this.exitCreateIntegration();
    };

    handlePayloadChange = checked => this.setState({ changesOnly: checked });

    exitCreateIntegration = () => this.setState({
        open: false,
        name: "",
        endpoint: "",
        changesOnly: false,
        format: "application/ld+json"
    });

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    render() {

        const { classes } = this.props;
        const { name, endpoint, format, isValidIRI, changesOnly } = this.state;

        return (
            <React.Fragment>
                <CreateButton onClick={this.handleClickOpen} label="Add Integration" />
                <Dialog
                    data-test="create-integration"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitAddLiteral} aria-labelledby="createintegration-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="createintegration-dialog-title">Add Integration</DialogTitle>
                    <DialogContent style={{ height: 400 }}>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="name"
                                name="name"
                                title="Name"
                                autoFocus
                                placeholder="Enter name of integration"
                                required={true}
                                text={name}
                                maxLength={MAX_INTEGRATIONNAME_LENGTH}
                                onChange={this.handleNameChange} />
                            <TitledTextField
                                margin
                                dataTest="endpoint"
                                name="endpoint"
                                title="Endpoint"
                                required={true}
                                error={!isValidIRI}
                                placeholder="Enter endpoint to send data to"
                                errorText={!isValidIRI ? "Endpoint is not a valid address." : ""}
                                text={endpoint}
                                maxLength={MAX_LONGIRI_LENGTH}
                                onChange={this.handleIRIChange} />
                            <div style={{ width: '100%', display: 'flex' }}>
                                <div style={{ flex: 1, marginRight: '8px' }}>
                                    <TitledPanel margin height="full" title="Format">
                                        <div style={{ marginTop: 10 }}>
                                            <MenuSelector
                                                dataTest="format-selector"
                                                handleChange={this.handleFormatChange}
                                                selected={format}
                                                hintWord="format"
                                                options={menuOptions} />
                                        </div>
                                    </TitledPanel>
                                </div>
                                <div style={{ flex: 1, marginLeft: '8px' }}>
                                    <TitledPanel margin height="full" title="Payload">
                                        <LabelledSwitch
                                            dataTest="changesOnly"
                                            checked={changesOnly}
                                            handleChange={this.handlePayloadChange}
                                            label="Changes Only" />
                                    </TitledPanel>
                                </div>
                            </div>
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitCreateIntegration} />
                        <PrimaryButton disabled={!isValidIRI || name === "" || endpoint === ""} onClick={this.createIntegration}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

CreateIntegrationDialog.propTypes = {
    classes: PropTypes.object,
    onCreateIntegration: PropTypes.func.isRequired
};

export default withStyles(styles)(CreateIntegrationDialog);